/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { bool, shape, string } from 'prop-types';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { getDonationsCategory } from '../../../../../../state/ducks/App/App-Selectors';

const useStyles = makeStyles((theme) => ({
    passportEligible: {
        padding: '0px 16px 0px',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.up('600')]: {
            display: 'inline-flex',
            padding: '0px 0px 10px 24px',
        },
    },
    passportEligibleImage: {
        width: '20px',
        height: '20px',
        marginRight: '12px',
    },
    passportEligibleContent: {
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.5px',
    },
}));
const PassportEligibleImage = ({
    presentationFamily, isPassportBannerEnabled, isPdpRedesignEnabled, passportData,
}) => {
    const classes = useStyles();
    const donationsCategoryName = useSelector(getDonationsCategory);

    const showPassportContent = presentationFamily === 'flower' && isPassportBannerEnabled && donationsCategoryName?.toLowerCase() !== 'donations';
    if (!showPassportContent && !isPdpRedesignEnabled) return <></>;
    const passportEligibleData = passportData.default_passport_messages?.passport_eligible || {};

    return (
        <div className={classes.passportEligible}>
            {passportEligibleData.icon?.url
            && (
                <div className={classes.passportEligibleImage}>
                    <ResponsiveImage
                        path={passportEligibleData.icon.url}
                        alt="Passport Eligible"
                        fullWidth
                    />
                </div>
            )}
            <div className={classes.passportEligibleContent}>{passportEligibleData?.tagline || 'Passport Eligible'}</div>
        </div>
    );
};

PassportEligibleImage.propTypes = {
    isPassportBannerEnabled: bool.isRequired,
    presentationFamily: string.isRequired,
    isPdpRedesignEnabled: bool,
    passportData: shape({
        default_passport_messages: shape({
            passport_eligible: shape({
                icon: string,
                tagline: string,
            }),
        }),
    }),
};
PassportEligibleImage.defaultProps = {
    isPdpRedesignEnabled: false,
    passportData: {},
};

export default PassportEligibleImage;
